import React, { Fragment } from 'react';
import TextButton from 'components/TextButton';

export const truncate = (text, textLimit, textTrimLimit, onClick) => {
  if (text.length > textLimit) {
    return (
      <Fragment>
        <div className="truncated-text" aria-hidden="true">
          {text.substring(0, textTrimLimit).trim()}
          {'... '}
          {onClick && (
            <TextButton className="read-more" onClick={() => onClick(text)}>
              (Read More)
            </TextButton>
          )}
        </div>
        <span className="sr-only">{text}</span>
      </Fragment>
    );
  } else {
    return text;
  }
};
